<template>
  <div>
    <LsInputLabel
      v-if="label || subLabel || collapseContent"
      :label="label"
      :sub-label="subLabel"
      :one-line-label="oneLineLabel"
      :collapse-content="collapseContent"
    />
    <BField :type="{ 'is-error': getValidation.invalid }" :message="getValidation.message">
      <BSelect
        v-model="localValue"
        v-validate="validation"
        :placeholder="placeholder"
        test-id="ls-select"
        :disabled="disabled || options.length === 1"
        :name="name"
      >
        <option
          v-for="option in options"
          :key="option.label"
          :value="option.value"
          :disabled="option.disabled"
          >{{ option.label }}</option
        >
      </BSelect>
    </BField>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import _ from 'lodash';
import LsInputLabel from '../LsInputLabel/LsInputLabel.vue';

export default {
  name: 'LsSelect',
  inject: ['$validator'],
  components: {
    LsInputLabel,
  },
  props: {
    value: VueTypes.any.isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    name: VueTypes.string.isRequired,
    options: VueTypes.arrayOf(
      VueTypes.shape({
        label: VueTypes.string.isRequired,
        value: VueTypes.any.isRequired,
        disabled: VueTypes.bool,
      })
    ).isRequired.loose, //TODO2: need loose for now to fix test errors for ChangeFrequncyModal
    label: VueTypes.string,
    subLabel: VueTypes.string,
    oneLineLabel: VueTypes.bool.def(false),
    collapseContent: VueTypes.string,
    // value prop must initialize as null for placeholder to show
    placeholder: VueTypes.string.def('- Select -'),
    disabled: VueTypes.bool.def(false),
    validation: VueTypes.object.def(_.constant(null)),
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        lsTrackingService.track({
          event: 'click',
          target: this.trackId,
          data: { value },
        });
        this.$emit('input', value);
      },
    },
    getValidation() {
      return lsValidationService.getValidation.call(this);
    },
  },
};
</script>

<style lang="scss">
.select {
  display: flex;
  select {
    border-radius: 0;
    border-color: $primary;
    width: 100%;
  }

  &:not(.is-multiple):not(.is-loading):not(.is-error)::after {
    border-color: $primary;
  }
}

.themed-app .select {
  &:not(.is-multiple):not(.is-loading):not(.is-error) {
    select,
    &::after {
      border-color: $theme-color-primary;
    }
  }

  &.is-error {
    select,
    &::after {
      border-color: $theme-color-danger;
    }
  }
}
</style>
